import { z } from "zod";
import { ServicedProductFieldsSchema } from "./ServicedProduct";
import { UserSchema } from "./User";

export const ServicedProductChangelogSchema = z.object({
  id: z.number(),
  fieldType: z.number(),
  fieldName: z.string(),
  oldValue: z.boolean(),
  newValue: z.boolean(),
  modificationDate: z.string(),
  accountUser: z.any(),
  attribute: z.any(),
  servicedProduct: ServicedProductFieldsSchema,
  userUser: UserSchema,
});
export const PartialServicedProductChangelogSchema =
  ServicedProductChangelogSchema.deepPartial();

export type PartialServicedProductChangelog = z.infer<
  typeof PartialServicedProductChangelogSchema
>;

export type ServicedProductChangelog = z.infer<
  typeof ServicedProductChangelogSchema
>;
